
export const MENU_BASE = [
    {
        title: 'Meu Painel',
        icon: 'fas fa-chart-line',
        link: '/dashboard',
        home: true,
        permissoes: ['dashboard', 'agenteadmin', 'root', 'admin']
    },
];

export const MENU_USA_TURISMO = [
    // {
    //     title: 'Transparência',
    //     icon: 'fas fa-sticky-note',
    //     link: '/turismo/transparencia',
    //     // class: "black-friday",
    //     permissoes: [],
    // },
    {
        title: 'Buscador',
        icon: 'fas fa-search',
        link: '/turismo/busca',
        permissoes: ['agente', 'consultor', 'comercial', 'admin', 'gerente'],
    },
    {
        title: '+FRT',
        icon: 'fa fa-plus',
        url: 'https://maisfrt.tur.br/',
        target: '_blank',
        permissoes: [],
    },
    // {
    //     title: 'Suporte',
    //     icon: 'fas fa-headset',
    //     url: 'https://portal-ag-frt.sydle.com/',
    //     target: '_blank',
    //     permissoes: [],
    // },
    // {
    //     title: 'Pronta Referência',
    //     icon: 'fas fa-percentage',
    //     link: '/turismo/pronta-referencia',
    //     // class: "black-friday",
    //     permissoes: [],
    // },
    // {
    //     title: 'Black November',
    //     icon: 'fas fa-percentage',
    //     link: '/turismo/black-november',
    //     permissoes: [],
    // },
    // {
    //     title: 'TODOS PELO RS',
    //     icon: 'fa fa-medkit',
    //     link: '/turismo/todos-pelo-rs',
    //     // class: "black-friday",
    //     permissoes: [],
    // },
    {
        title: 'Disney',
        icon: 'fab fa-fort-awesome',
        link: '/turismo/listagem-pacotes-disney/pacotes-disney',
        permissoes: ['admin', 'pacotes-disney'],
    },
    {
        title: 'Beto Carrero',
        icon: 'fa fa-hat-cowboy-side',
        link: '/turismo/beto-carrero',
        permissoes: [],
    },
    // {
    //     title: "Serviços pelo Mundo",
    //     // icon: "fa fa-globe",
    //     icon: "fa fa-paper-plane",
    //     link: "/turismo/promocional",
    //     permissoes: [],
    // },
    // {
    //     title: 'Campanha',
    //     icon: 'fas fa-rocket',
    //     link: '/turismo/campanha',
    //     permissoes: [],
    // },
    // {
    //     title: 'Casamentos',
    //     icon: 'fas fa-ring',
    //     link: '/turismo/listagem-pacotes-casamentos/pacotes-casamentos',
    //     permissoes: ['admin','pacotes-casamentos'],
    //   },
    // {
    //     title: 'BLACKFRIDAY',
    //     icon: 'fas fa-percentage',
    //     link: '/turismo/black-friday',
    //     class: "black-friday",
    //     permissoes: [],
    // },

    {
        title: 'Roteiros',
        icon: 'fa fa-globe',
        link: '/turismo/listagem-pacotes/roteiros/pacotes',
        permissoes: ['admin', 'pacotes'],
    },
    {
        title: 'Rodoviário',
        icon: 'fa fa-bus',
        link: '/turismo/listagem-pacotes/rodoviario/pacotes',
        permissoes: ['admin', 'cadastro_bloqueiorodoviario'],
    },
    {
        title: 'Bloqueios',
        icon: 'fas fa-plane',
        link: '/gerenciamento/lista-bloqueio-aereos',
        permissoes: ['agente', 'consultor', 'comercial', 'admin', 'gerente'],
    },
    {
        title: 'FRT Cruzeiros',
        icon: 'fa fa-ship',
        url: 'https://frtoperadora.krooze.com.br/',
        target: '_blank',
        permissoes: [],
    },
    {
        title: 'Oportunidades Aéreo',
        icon: 'fa fa-fighter-jet',
        url: 'https://app.powerbi.com/view?r=eyJrIjoiZjVhZmE4MGEtZjM0ZC00MzNmLWE1MWEtOTMwMmMwMDc3MWM2IiwidCI6IjkwMDU2MDQ5LTIxNGEtNDhhMS05ZTAyLTcyZmU3M2U3MDU4YyJ9',
        target: '_blank',
        permissoes: [],
    },
    {
        title: 'Meus Orçamentos',
        icon: 'fas fa-book',
        link: '/meus-orcamentos',
        permissoes: ['agente', 'consultor', 'comercial', 'admin', 'gerente', 'fornecedor'],
    },

];

export const MENU_MINHA_AGENCIA = [
    {
        title: 'Meu Cadastro',
        icon: 'fas fa-store-alt',
        link: '/cadastro/agencia/minha',
        permissoes: ['agente'],
    },
];

export const MENU_FINANCEIRO = [
    {
        title: 'Financeiro',
        icon: 'fas fa-dollar-sign',
        permissoes: ['televendas', 'admin', 'cadastro_cambio', 'atualiza_cambio', 'agente',
            'consultor', 'comercial', 'cadastro_forma_pagamento', 'lancar_recebimento', 'cadastro_moeda', 'root', 'agencia_add_credito',
            'contratos', 'agencia_financeiro_faturas', 'financiamento_ver'
        ],
        children: [
            {
                title: 'Cambio',
                link: '/gerenciamento/cambio',
                permissoes: ['admin', 'cadastro_cambio', 'atualiza_cambio', 'visualiza_cambio'],
            },
            {
                title: "Contratos",
                link: "/gerenciamento/contratos",
                permissoes: ['contratos', 'root', 'admin'],
            },
            {
                title: "Faturas",
                link: "/turismo/faturas",
                permissoes: ['agenteadmin', 'consultor', 'comercial', 'root', 'admin', 'gerente', 'agencia_financeiro_faturas'],
            },
            {
                title: 'Financiamentos',
                link: '/gerenciamento/financiamentos',
                permissoes: ['agente', 'consultor', 'comercial', 'financiamento_ver'],
            },
            {
                title: 'Formas de Pagamento',
                link: '/gerenciamento/forma-pagamento',
                permissoes: ['cadastro_forma_pagamento'],
            },
            {
                title: 'Pagamentos Cartões',
                link: '/gerenciamento/reservapagamentoscartoes',
                permissoes: ['admin', 'root', 'gerente', 'consultor'],
            },
            {
                title: 'Restabelecer Saldo',
                link: '/gerenciamento/restabelecer-saldo',
                permissoes: ['lancar_recebimento', 'admin', 'root', 'agencia_add_credito'],
            },
            {
                title: 'Moedas',
                link: '/gerenciamento/moeda',
                permissoes: ['cadastro_moeda'],
            },
            {
                title: 'TeleVendas',
                link: '/gerenciamento/televendaspagamento',
                permissoes: ['televendas'],
            },
        ],
    },
];

export const MENU_CADASTRO = [
    {
        title: 'Cadastro',
        icon: 'fas fa-edit',
        permissoes: ['admin', 'cadastro_pais', 'cadastro_estado', 'cadastro_cidade',
            'cadastro_aeroporto', 'cadastro_bloqueio_aereo', 'gestao_cache_hotel',
            'cadastro_grupo_economico', 'cadastro_hotel', 'cadastro_hotel_tarifar',
            'cadastro_servico_fornecedor', 'cadastro_regime', 'root', 'cadastro_subfornecedor',
            'cadastro_usuario', 'cadastro_pacote', 'cadastro_laminas', 'cadastro_banner', 'cadastro_carro', 'cadastro_bloqueiorodoviario',
            'fornecedor_tarifar', 'fornecedor'

        ],
        children: [
            {
                title: 'Países',
                link: '/gerenciamento/pais',
                permissoes: ['cadastro_pais'],
            },
            {
                title: 'Estados',
                link: '/gerenciamento/estado',
                permissoes: ['cadastro_estado'],
            },
            {
                title: 'Cidades',
                link: '/gerenciamento/cidade',
                permissoes: ['cadastro_cidade'],
            },
            {
                title: 'Comunicados',
                link: '/gerenciamento/comunicado',
                permissoes: ['cadastro_comunicado'],
            },
            {
                title: 'Aeroportos',
                link: '/gerenciamento/aeroporto',
                permissoes: ['cadastro_aeroporto'],
            },
            {
                title: 'Bloqueio Aéreo',
                link: '/gerenciamento/bloqueioaereo',
                permissoes: ['cadastro_bloqueio_aereo'],
            },
            {
                title: 'Política Voucher',
                link: '/gerenciamento/politicavoucher',
                permissoes: ['cadastro_bloqueio_aereo'],
            },
            {
                title: 'Cache Hotel',
                link: '/gerenciamento/cachehotel',
                permissoes: ['gestao_cache_hotel'],
            },
            {
                title: 'Empresas *Lojas*',
                link: '/cadastro/empresa',
                permissoes: ['admin']
            },
            {
                title: 'Grupo Econômico',
                link: '/cadastro/grupo-economico',
                permissoes: ['cadastro_grupo_economico'],
            },
            {
                title: 'Hotel Offline',
                link: '/gerenciamento/hoteloffline',
                permissoes: ['cadastro_hotel', 'cadastro_hotel_tarifar'],
            },
            {
                title: 'Produto Offline - Fornecedor',
                link: '/gerenciamento/produtoofflinefornecedor',
                permissoes: ['admin', 'root'],
            },
            {
                title: 'Produto Offline - Tipo',
                link: '/cadastro/tipos-de-produtos',
                permissoes: ['admin', 'root'],
            },
            {
                title: 'Produto',
                link: '/gerenciamento/produto',
                permissoes: ['admin', 'root', 'cadastro_produto'],
            },
            {
                title: 'Produto - Tipo',
                link: '/gerenciamento/produtotipo',
                permissoes: ['admin', 'root', 'cadastro_produto'],
            },
            {
                title: 'Pacote',
                link: '/gerenciamento/pacote',
                permissoes: ['admin', 'root', 'cadastro_pacote'],
            },
            {
                title: 'Pacote - Tipo',
                link: '/gerenciamento/pacotetipo',
                permissoes: ['admin', 'root', 'cadastro_pacote'],
            },
            {
                title: 'Pacote - Destino',
                link: '/gerenciamento/pacotedestino',
                permissoes: ['admin', 'root', 'cadastro_pacote']
            },
            {
                title: 'Regimes',
                link: '/gerenciamento/regimes',
                permissoes: ['cadastro_regime'],
            },
            {
                title: 'Serviço Offline',
                link: '/gerenciamento/servicooffline',
                permissoes: ['cadastro_servico', 'cadastro_servico_tarifar', 'fornecedor'],
            },
            {
                title: 'Serviço Offline-Tipo',
                link: '/gerenciamento/servicoofflinetipo',
                permissoes: ['cadastro_servico_fornecedor'],
            },
            {
                title: 'Serviço Offline - Fornecedor',
                link: '/gerenciamento/servicoofflinefornecedor',
                permissoes: ['cadastro_servico_fornecedor', 'fornecedor'],
            },
            {
                title: 'Carro Offline',
                link: '/gerenciamento/carrooffline',
                permissoes: ['admin', 'root', 'cadastro_carro'],
            },
            {
                title: 'SubFornecedores',
                link: '/gerenciamento/subfornecedor',
                permissoes: ['cadastro_subfornecedor'],
            },
            {
                title: 'Tarifário de Serviço',
                link: '/gerenciamento/tarifarioservico',
                permissoes: ['admin', 'root', 'fornecedor_tarifar', 'fornecedor'],
            },
            {
                title: 'Usuários',
                link: '/cadastro/usuario',
                permissoes: ['admin', 'cadastro_usuario'],
            },
            // {
            //     title: 'Relatorio',
            //     link: '/gerenciamento/relatorio-cadastro',
            //     permissoes: ['admin', 'cadastro_relatorio'],
            // },
            {
                title: 'Cadastro - Lâminas',
                link: '/cadastro/cadastro-laminas',
                permissoes: ['admin', 'root', 'cadastro_laminas'],
            },
            {
                title: 'Cadastro - Banner',
                link: '/cadastro/cadastro-banner',
                permissoes: ['admin', 'root', 'cadastro_banner'],
            },
            {
                title: 'Campanha - Etapa',
                link: '/gerenciamento/campanhaetapa',
                permissoes: ['admin', 'root', 'cadastro_campanha'],
            },
            {
                title: 'Campanha - Metas',
                link: '/gerenciamento/campanhameta',
                permissoes: ['admin', 'root', 'cadastro_campanha'],
            },
            {
                title: 'Pensões',
                link: '/cadastro/pensoes',
                permissoes: ['admin', 'root', 'cadastro_pensao'],
            },
            {
                title: 'Padrões de Pensão - Fornecedor',
                link: '/cadastro/padrao-pensao-fornecedor',
                permissoes: ['admin', 'root', 'cadastro_pensao'],
            },
            {
                title: 'Cadastro de Agências',
                link: '/gerenciamento/cadastro-agencias',
                permissoes: ['admin', 'root', 'cadastro_agencia'],
            },
            {
                title: "Rodoviário",
                children: [
                    {
                        title: "Cia",
                        link: "/gerenciamento/rodoviario/cia",
                    },
                    {
                        title: "Tarifario",
                        link: "/gerenciamento/rodoviario/tarifario",
                    },
                ],
                permissoes: ['admin', 'root', 'cadastro_bloqueiorodoviario'],
            }
        ],
    },
];

export const MENU_GERENCIAMENTO = [
    {
        title: 'Gerenciamento',
        icon: 'fas fa-clipboard',
        permissoes: ['admin', 'cadastro_perfil_markup', 'gerador_relatorios', 'comercial'],
        children: [
            // {
            //     title: 'Gerador de Relatórios',
            //     link: '/gerenciamento/gerador-relatorio',
            //     permissoes: ['admin', 'gerador_relatorios']
            // },
            {
                title: 'Relatórios Gerais',
                link: '/gerenciamento/relatorios-gerais',
                permissoes: ['admin', 'relatorios_gerais', 'comercial']
            },
            {
                title: 'Parâmetros do Sistema',
                link: '/configuracao/parametro',
                permissoes: ['admin']
            },
            {
                title: 'Perfil de Usuários',
                link: '/configuracao/perfilusuario',
                permissoes: ['admin']
            },
            {
                title: 'Perfil Markup',
                link: '/gerenciamento/perfilmarkup',
                permissoes: ['cadastro_perfil_markup'],
            },
            {
                title: 'WebServices',
                link: '/gerenciamento/webservice',
                permissoes: ['admin'],
            },
            ,
            {
                title: 'Manutenção',
                link: '/gerenciamento/manutencao',
                permissoes: ['manutencao'],
            },
            //gerenciamento/manutencao
        ],
    },
];

export const MENU_GESTAO_RESERVAS = [
    {
        title: 'Gestão de Reservas',
        icon: 'fas fa-tasks',
        permissoes: ['monitoramento_acesso', 'monitoramento_alterar', 'manutencao_reserva', 'reservas_palladium', 'liberar_voucher'],
        children: [
            {
                title: 'Monitoramento de Reservas',
                link: '/gerenciamento/monitoramento-reservas',
                permissoes: ['monitoramento_acesso', 'monitoramento_alterar'],
            },
            {
                title: 'Manutenção de Reservas',
                link: '/gerenciamento/manutencao-reservas',
                permissoes: ['manutencao_reserva'],
            },
            {
                title: 'Reservas Palladium',
                link: '/gerenciamento/listareservaspalladium',
                permissoes: ['reservas_palladium'],
            },
            {
                title: 'Liberar Vouchers',
                link: '/gerenciamento/liberavoucher',
                permissoes: ['liberar_voucher'],
            },
        ],
    },
];


export const MENU_AGENCIA = [
    {
        title: 'Agências',
        icon: 'fas fa-store-alt',
        link: '/cadastro/agencia',
        permissoes: ['consultor', 'comercial', 'financeiro', 'gerente'],
    },
];

export const MENU_EVENTOS = [
    {
        title: 'Notificações',
        icon: 'fas fa-newspaper-o',
        permissoes: ['admin', 'root'],
        children: [
            // {
            //     title: 'Eventos',
            //     link: '/gerenciamento/evento',
            //     permissoes: ['admin', 'root', 'eventos'],
            // },
            {
                title: 'Enviar Notificação',
                link: '/gerenciamento/notificacao',
                // permissoes: ['admin', 'root', 'eventos'],
                permissoes: ['admin', 'root'],
            },
            {
                title: 'Grupo Notificacao',
                link: '/gerenciamento/gruponotificacao',
                // permissoes: ['admin', 'root', 'eventos'],
                permissoes: ['admin', 'root'],
            }
        ],
    },
];

export const MENU_GRUPOS_CASAMENTOS = [
    {
        title: 'Grupos / Casamentos',
        icon: 'fa fa-users',
        permissoes: ['admin', 'root', 'cadastro_grupo'],
        children: [
            {
                title: 'Formulário de Solicitação',
                //url: 'https://forms.gle/UNRJobEZF21LzwNy5',
                link: '/cadastro/grupo',
                permissoes: ['admin', 'root', 'cadastro_grupo']
            }
        ],
    },
];

export const MENU_INTRANET = [
    {
        title: 'Intranet',
        icon: 'fas fa-network-wired',
        children: [
            {
                title: 'Dashboard',
                link: '/intranet/dashboard',
                permissoes: ['admin', 'root', 'intranet'],
            },
            {
                title: 'Categoria',
                link: '/intranet/categoria',
                permissoes: ['admin', 'root', 'cadastro_intranet'],
            },
            {
                title: 'Grupo',
                link: '/intranet/grupo',
                permissoes: ['admin', 'root', 'cadastro_intranet'],
            },
            {
                title: 'Conteúdo',
                link: '/intranet/conteudo',
                permissoes: ['admin', 'root', 'cadastro_intranet'],
            },
            {
                title: "Voucher",
                link: "/intranet/voucher",
                permissoes: ['voucher_grupo'],
            },
            {
                title: "Material Promocional",
                permissoes: ['marketing'],
                children: [
                    {
                        title: "Grupo",
                        link: "/intranet/materialpromocional/grupo",
                        // permissoes: [''],
                    },
                    {
                        title: "Material",
                        link: "/intranet/materialpromocional/material",
                        // permissoes: [''],
                    },

                    {
                        title: "Tag",
                        link: "/intranet/materialpromocional/tag",
                        // permissoes: [''],
                    }
                ]
            },
            // ,
            // {
            //   title: 'Lista bloqueio AGTS',
            //   link: '/gerenciamento/lista-bloqueio-agts',
            //   permissoes: [],
            // },
        ],
        permissoes: ['intranet_gestao', 'intranet', 'cadastro_intranet'],
    },
];

// export const MENU_INTRANET_DASHBOARD = [
//   {
//     title: 'Intranet',
//     icon: 'fas fa-store-alt',
//     link: '/intranet/dashboard',
//     permissoes: ['admin','root'],
//   },
// ];

export const MENU_GESTAO_FORNECEDORES = [

    {
        title: 'Gestão de Fornecedores',
        icon: 'fas fa-cog',
        permissoes: ['admin', 'importacao_hotel_beds', 'importacao_restel', 'cidades_ezlink'],
        children: [
            {
                title: 'Importação HotelBeds',
                link: '/gerenciamento/importacaohotelbeds',
                permissoes: ['importacao_hotel_beds'],
            },
            {
                title: 'Importação Restel',
                link: '/gerenciamento/importacaorestel',
                permissoes: ['importacao_restel'],
            },
            {
                title: 'Importação RIU',
                link: '/gerenciamento/importacaoriu',
                permissoes: ['admin'],
            },
            {
                title: 'Cidades EzLink (Novo)',
                link: '/cadastro/ezlink',
                permissoes: ['cidades_ezlink'],
            },
            //   {
            //     title: 'Cidades TBO',
            //     link: '/cadastro/tbo',
            //     permissoes: ['cidades_tbo'],
            //   },
            {
                title: 'Vincular Cidade nos Hotéis',
                link: '/cadastro/juniper-api',
                permissoes: ['cidades_juniperapi'],
            },
            {
                title: 'Blacklist Hotel',
                link: '/gerenciamento/blacklisthotel',
                permissoes: ['black_list_hotel'],
            },
            {
                title: 'Vendas Beto Carrero',
                link: '/gerenciamento/vendas-beto-carrero',
            }
        ],
    },
];

// export const MENU_SUPORTE = [
//     {
//         title: 'Suporte',
//         icon: 'fas fa-headset',
//         url: 'https://portal-ag-frt.sydle.com/',
//         permissoes: [],
//     },
// ];

export const MENU_USUARIOS = [
    {
        title: 'Auth',
        icon: 'nb-locked',
        permissoes: [],
        children: [
            {
                title: 'Login',
                link: '/auth/login/pt',
                permissoes: [],
            },
            {
                title: 'Register',
                link: '/auth/register',
                permissoes: [],
            },
            {
                title: 'Request Password',
                link: '/auth/request-password',
                permissoes: [],
            },
            {
                title: 'Reset Password',
                link: '/auth/reset-password',
                permissoes: [],
            },
        ],
    },
];
